import {
  useQuery,
} from '@tanstack/react-query';
import { ISection } from '../../interfaces/Section';
import {
  getSectionByIdV2,
  getSectionSubcategoriesV2,
  getSectionsV2
} from '../../services/sections.service';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
const listQueryKey = 'sections';

export const useGetSections = (enabled: boolean, query?: {
  storeId?: string
  isActive?: boolean
  products?: boolean
}) => useQuery<ISection[]>({
  queryKey: [listQueryKey, { query }],
  enabled: enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key] = queryKey
      const res = await getSectionsV2(query);
      if (!res?.data?.data?.sections) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data.sections;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      backendErrorsHandler(e);
      throw e;
    }
  }
});

export const useGetSectionById = (id: string, storeId: string) => useQuery<ISection>({
  queryKey: [listQueryKey, { _id: id, storeId }],
  enabled: !!id && !!storeId,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { _id: _id }] = queryKey;
      const res = await getSectionByIdV2(_id);
      if (!res?.data?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      backendErrorsHandler(e);
      throw e;
    }
  }
});

export const useGetSectionSubcategories = (sectionId: string, enabled: boolean) =>
  useQuery<ISection[]>({
    queryKey: [listQueryKey, 'subcategories', sectionId],
    enabled,
    queryFn: async () => {
      try {
        const res = await getSectionSubcategoriesV2(sectionId);
        if (!res?.data?.data?.subcategories) {
          throw new Error('Oh no! Something went wrong while fetching.');
        }
        return res.data.data.subcategories as ISection[];
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    }
  });
